/* eslint-disable react/jsx-props-no-spreading */
import React, {
  createContext,
  useContext,
  useMemo,
  useRef,
} from "react";

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const hideExitPopupRef = useRef(false);
  const hidePromoPopupRef = useRef(false);
  const forceClosePromoPopupRef = useRef(false);

  const hideExitPopup = () => {
    hideExitPopupRef.current = true;
  };

  const contextValue = useMemo(
    () => ({ hideExitPopupRef, hidePromoPopupRef, forceClosePromoPopupRef, hideExitPopup }),
    [hideExitPopupRef, hidePromoPopupRef, forceClosePromoPopupRef, hideExitPopup],
  );
  return (
    <PopupContext.Provider value={contextValue}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within a PopupContext');
  }
  return context;
};

export const withPopup = (Component) => (props) => (
  <PopupContext.Consumer>
    {(context) => <Component {...props} themeContext={context} />}
  </PopupContext.Consumer>
);
